import { actionTypes as actionTypesCore } from '@core/js/components/system/App/store/constants';

import { TAG_TYPE_BUZZ } from '@interlayer/js/components/system/TagManager/buzz/constants';
import { TAppConfigTag } from '@interlayer/js/components/system/TagManager/buzz/types';

import { actionTypes } from './constants';
import { IUpdateMenuItems, TRemoveActiveTagConfig, TResizeData } from './types';

type Action<T extends actionTypes, P> = {
    type: T;
    payload: P;
};

export const setShowMobileMenu = (isShowMobileMenu: boolean): Action<actionTypes.SET_SHOW_MOBILE_MENU, boolean> => ({
    type: actionTypes.SET_SHOW_MOBILE_MENU,
    payload: isShowMobileMenu
});

export const setIsFeaturedBanner = (isFeaturedBanner: boolean): Action<actionTypes.SET_IS_FEATURED_BANNER, boolean> => ({
    type: actionTypes.SET_IS_FEATURED_BANNER,
    payload: isFeaturedBanner
});

export const setShowLocalPopup = (isShowLocalPopup: boolean): Action<actionTypes.SET_IS_SHOW_LOCAL_POPUP, boolean> => ({
    type: actionTypes.SET_IS_SHOW_LOCAL_POPUP,
    payload: isShowLocalPopup
});

export const setShowAccountMenu = (isShowAccountMenu: boolean): Action<actionTypes.SET_SHOW_ACCOUNT_MENU, boolean> => ({
    type: actionTypes.SET_SHOW_ACCOUNT_MENU,
    payload: isShowAccountMenu
});

export const setShowPopupAlreadyUser = (isShow: boolean): Action<actionTypes.SET_IS_SHOW_POPUP_ALREADY_USER, boolean> => ({
    type: actionTypes.SET_IS_SHOW_POPUP_ALREADY_USER,
    payload: isShow
});

export const setUrlRedirectBackAfterDeposit = (redirectUrl: string): Action<
    actionTypes.SET_URL_REDIRECT_BACK_AFTER_DEPOSIT,
    string
> => ({
    type: actionTypes.SET_URL_REDIRECT_BACK_AFTER_DEPOSIT,
    payload: redirectUrl
});

export const setIsShowPlayBingoButton = (isShow: boolean): Action<actionTypes.SET_IS_SHOW_PLAY_BINGO_BUTTON, boolean> => ({
    type: actionTypes.SET_IS_SHOW_PLAY_BINGO_BUTTON,
    payload: isShow
});

export const setIsShowTag = (
    type: TAG_TYPE_BUZZ,
    isShow: boolean
): Action<actionTypes.SET_IS_SHOW_TAG, { type: TAG_TYPE_BUZZ; isShow: boolean }> => ({
    type: actionTypes.SET_IS_SHOW_TAG,
    payload: { type, isShow }
});

export const setActiveTagConfig = (tag: TAppConfigTag): Action<actionTypes.SET_ACTIVE_TAG_CONFIG, TAppConfigTag> => ({
    type: actionTypes.SET_ACTIVE_TAG_CONFIG,
    payload: tag
});

export const removeActiveTagConfig = (
    tag: TRemoveActiveTagConfig
): Action<actionTypes.REMOVE_ACTIVE_TAG_CONFIG, TRemoveActiveTagConfig> => ({
    type: actionTypes.REMOVE_ACTIVE_TAG_CONFIG,
    payload: tag
});

export const updateMenuItems = ({ menuItems, menuItemsOnlyIsLoggedIn }: IUpdateMenuItems): {
    type: actionTypesCore.UPDATE_MENU_ITEMS;
    payload: IUpdateMenuItems;
} => ({
    type: actionTypesCore.UPDATE_MENU_ITEMS,
    payload: { menuItems, menuItemsOnlyIsLoggedIn }
});

export const setResizeData = (resizeData: TResizeData): Action<actionTypes.SET_RESIZE_DATA, TResizeData> => ({
    type: actionTypes.SET_RESIZE_DATA,
    payload: resizeData
});

export const setIsDownloadAppOpen = (status: boolean): Action<actionTypes.SET_IS_DOWNLOAD_APP_OPEN, boolean> => ({
    type: actionTypes.SET_IS_DOWNLOAD_APP_OPEN,
    payload: status
});

export const setPositionStickyBtn = (positionStickyBtn: string): Action<actionTypes.SET_POSITION_STICKY_BUTTON, string> => ({
    type: actionTypes.SET_POSITION_STICKY_BUTTON,
    payload: positionStickyBtn
});
